import { render, staticRenderFns } from "./WebInquiries.vue?vue&type=template&id=17ccf3e0&scoped=true&"
import script from "./WebInquiries.vue?vue&type=script&lang=js&"
export * from "./WebInquiries.vue?vue&type=script&lang=js&"
import style0 from "./WebInquiries.vue?vue&type=style&index=0&id=17ccf3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ccf3e0",
  null
  
)

export default component.exports